import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axiosInstance from '../../api/axiosInstance';

const SmsSetting = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [smsSettingData, setSmsSettingData] = useState(null);

    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        api_url: '',
        username: '',
        password: '',
        sender: '',
        lang: '',
        enabled: 0
    });

    const fetchTerms = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get('getSmsSetting/1');

            if (response.status === 200 && response.data?.data) {
                const smsData = Array.isArray(response.data.data)
                    ? response.data.data[0]
                    : response.data.data;

                setSmsSettingData(smsData);
                setFormData({
                    api_url: smsData.api_url || '',
                    username: smsData.username || '',
                    password: smsData.password || '', // Password might come back empty or hashed
                    sender: smsData.sender || '',
                    lang: smsData.lang || '',
                    enabled: smsData.enabled || 0
                });
            } else {
                Swal.fire("Error", "Failed to fetch SMS setting", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTerms();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
        }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        // Reset form data to original fetched data
        if (smsSettingData) {
            setFormData({
                api_url: smsSettingData.api_url || '',
                username: smsSettingData.username || '',
                password: smsSettingData.password || '',
                sender: smsSettingData.sender || '',
                lang: smsSettingData.lang || '',
                enabled: smsSettingData.enabled || 0
            });
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await axiosInstance.put('updateSmsSetting/1', formData);

            if (response.status === 200) {
                Swal.fire("Success", "SMS Setting updated successfully", "success");
                setIsEditing(false);
                fetchTerms(); // Refresh data
            } else {
                Swal.fire("Error", "Failed to update SMS setting", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong during update", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="spinner-border text-primary" />
                    </div>
                ) : (
                    <>
                        <h5>
                            <i className="fa fa-arrow-left me-2" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
                            SMS Setting
                        </h5>

                        {smsSettingData?.id || isEditing ? ( // Show if data exists OR if we are in editing mode (though usually we edit existing)
                            <div className="card p-4">
                                {!isEditing ? (
                                    <>
                                        <div className="d-flex justify-content-end">
                                            <button className="btn btn-primary btn-sm mb-3" onClick={handleEdit}>
                                                <i className="fa fa-edit me-2"></i>Edit
                                            </button>
                                        </div>

                                        <p><b>API URL:</b> {smsSettingData?.api_url}</p>
                                        <p><b>Username:</b> {smsSettingData?.username}</p>
                                        <p><b>Sender:</b> {smsSettingData?.sender}</p>
                                        <p><b>Language:</b> {smsSettingData?.lang}</p>
                                        <p><b>Enabled:</b> {smsSettingData?.enabled == 1 ? "Yes" : "No"}</p>
                                    </>
                                ) : (
                                    <form onSubmit={handleUpdate}>
                                        <div className="mb-3">
                                            <label className="form-label">API URL</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="api_url"
                                                value={formData.api_url}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Username</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="username"
                                                value={formData.username}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Password</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Sender</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="sender"
                                                value={formData.sender}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Language</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="lang"
                                                value={formData.lang}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3 form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="enabledCheck"
                                                name="enabled"
                                                checked={formData.enabled == 1}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="enabledCheck">Enabled</label>
                                        </div>

                                        <button type="submit" className="btn btn-primary">Update</button>
                                        <button type="button" className="cancelText" onClick={handleCancel}>Cancel</button>
                                    </form>
                                )}
                            </div>
                        ) : (
                            <div className="card text-center p-5">
                                <h5>No SMS Setting Found</h5>
                            </div>
                        )}
                    </>
                )}

            </div>
        </div>
    );
};

export default SmsSetting;
